import classnames from "classnames";
import { Link } from "gatsby";
import React from "react";

import IconArrow from "../../assets/IconArrow";
import capitalise from "../../utils/capitalise";
import * as styles from "./AppLink.module.css";

const AppLink = ({
  type,
  className,
  to = "",
  children,
  marginTop,
  activeClassName,
  partiallyActive,
  plain,
  color,
  backgroundColor,
  alt,
  external,
  largeExternal,
  normalBodyText,
  darkOnLight,
  lightOnDark,
  noLink,
  ...props
}) => {
  const classes = classnames(
    styles.appLink,
    {
      [styles.buttonLink]: type === "button",
      [styles.buttonLinkAlt]: type === "buttonAlt",
      [styles.arrowLink]: type === "arrow" || type === "arrowReverse",
      [styles.arrowLinkReverse]: type === "arrowReverse",
      [styles.marginTop]: marginTop,
      [styles.lightOnDark]: lightOnDark || plain === "lightOnDark",
      [styles.darkOnLight]: darkOnLight || plain === "darkOnLight",
      [styles.backgroundLightOnDark]: backgroundColor === "lightOnDark",
      [styles.backgroundLightOnDarkAlt]: backgroundColor === "lightOnDarkAlt",
      [styles.alt]: alt,
      [styles.external]: external,
      [styles.largeExternal]: largeExternal,
      [styles.normalBodyText]: normalBodyText
    },
    `color${capitalise(color)}`,
    `background${capitalise(backgroundColor)}`,
    `smallBodyText`,
    className
  );

  const linkBody = (
    <>
      {type === "arrowReverse" && (
        <span className={styles.iconArrowWrapper}>
          <IconArrow
            className={styles.iconArrow}
            color={color || "offBlack"}
            direction="left"
            lightOnDark={lightOnDark}
          />
        </span>
      )}
      {children}
      {type === "arrow" && (
        <span className={styles.iconArrowWrapper}>
          <IconArrow
            className={styles.iconArrow}
            color={color || "offBlack"}
            lightOnDark={lightOnDark}
          />
        </span>
      )}
    </>
  );

  if (noLink){
    return <div className={classes}>{linkBody}</div>;
  }
  
  if (!external) {
    return (
      <Link
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        className={classes}
        {...props}
      >
        {linkBody}
      </Link>
    );
  }


  return (
    <a
      href={to}
      {...props}
      className={classes}
      target="_blank"
      rel="noreferrer"
    >
      {children}
      <span className={styles.iconExternalWrapper}>
        <span className={styles.iconExternalBox} />
        <span className={styles.iconExternalArrow}>
          <IconArrow color={color || "offBlack"} tail />
        </span>
      </span>
    </a>
  );
};

export default AppLink;
